import React from 'react';
import { Plus, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader } from '../ui/card';
import { Button } from '../ui/button';
import { VisitCard } from './VisitCard';

export function CalendarGrid({ 
  weekDates, 
  entries, 
  filterStaff, 
  filterClient, 
  loading, 
  onVisitClick,
  onQuickAdd 
}) {
  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const getEntriesForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return entries.filter(entry => {
      const matchesDate = entry.scheduled_date === dateStr;
      const matchesStaff = filterStaff === 'all' || entry.staff_id === filterStaff;
      const matchesClient = filterClient === 'all' || entry.client_id === filterClient;
      return matchesDate && matchesStaff && matchesClient;
    });
  };

  if (loading) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-teal-600" />
          <p className="text-slate-500 mt-2">Loading schedule...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-7 gap-2">
      {weekDates.map((date, idx) => {
        const dayEntries = getEntriesForDate(date);
        const dayName = date.toLocaleDateString('en-GB', { weekday: 'short' });
        const dayNum = date.getDate();

        return (
          <Card key={idx} className={`min-h-[400px] ${isToday(date) ? 'ring-2 ring-teal-500' : ''}`}>
            <CardHeader className={`pb-2 ${isToday(date) ? 'bg-teal-50' : ''}`}>
              <div className="text-center">
                <p className="text-xs text-slate-500">{dayName}</p>
                <p className={`text-lg font-bold ${isToday(date) ? 'text-teal-600' : ''}`}>{dayNum}</p>
              </div>
            </CardHeader>
            <CardContent className="p-2 space-y-2">
              {dayEntries.length > 0 ? (
                dayEntries.map(entry => (
                  <VisitCard key={entry.id} entry={entry} onClick={onVisitClick} />
                ))
              ) : (
                <p className="text-xs text-slate-400 text-center py-4">No visits</p>
              )}

              {/* Quick add button */}
              <Button
                variant="ghost"
                size="sm"
                className="w-full text-xs opacity-50 hover:opacity-100"
                onClick={() => onQuickAdd(date)}
              >
                <Plus className="w-3 h-3 mr-1" /> Add
              </Button>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
